import { render, staticRenderFns } from "./ClientPreferences.vue?vue&type=template&id=08cd7d5d&scoped=true&"
import script from "./ClientPreferences.vue?vue&type=script&lang=js&"
export * from "./ClientPreferences.vue?vue&type=script&lang=js&"
import style0 from "./ClientPreferences.vue?vue&type=style&index=0&id=08cd7d5d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cd7d5d",
  null
  
)

export default component.exports